import { updateGuestForm } from '../../../redux/actions/guests';

export function updateGuestFormUtil(form, isAdmin, adminOnChange, dispatch) {
	if(isAdmin) {
		adminOnChange(form);
	} else {
		dispatch(updateGuestForm(form));
	}
}